import { render, staticRenderFns } from "./CadEmpresa.vue?vue&type=template&id=2e039f69&"
import script from "./CadEmpresa.vue?vue&type=script&lang=js&"
export * from "./CadEmpresa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports